import { render, staticRenderFns } from "./BlankBaseTemplate.vue?vue&type=template&id=a5a0aa94&"
import script from "./BlankBaseTemplate.vue?vue&type=script&lang=js&"
export * from "./BlankBaseTemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports